import type { LoadingState } from '@ipfabric/ui-components/utils/loading/withLoadingIndicator';
import classNames from 'classnames';
import { ButtonAsA } from 'components/Button/ButtonAsA';
import { useLocale } from 'containers/App/LocaleContext';
import { LoaderAndText } from 'containers/LoaderAndText/LoaderAndText';
import type { FC, ReactNode } from 'react';

interface Props {
  children: ReactNode;
  errorClassName?: string;
  loadingState: LoadingState;
  onRecover: () => void;
}

export const RecoverableLoader: FC<Props> = (props) => {
  const { recoverableLoader: msg } = useLocale();

  switch (props.loadingState) {
    case 'LOADING':
      return <LoaderAndText />;
    case 'ERROR':
      return (
        <p
          className={classNames(
            props.errorClassName,
            'text-danger text-center',
          )}
        >
          {msg.failedToFetch}{' '}
          <ButtonAsA onClick={props.onRecover}>{msg.tryAgain}</ButtonAsA>
        </p>
      );
    default:
      return <>{props.children}</>;
  }
};
